export default __webpack_public_path__ + "static/media/5w40.ae420d82.png";